import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/geist'
import '@fontsource-variable/geist-mono'
import './design/tokens.css'
import './design/base.css'
import './design/components.css'
import './design/app.css'
import './design/editor.css'
import App from './App'
import { applyThemeEarly } from './theme'

// Before the first paint, so there is no flash of the wrong theme.
applyThemeEarly()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
